import type { ZudokuConfig } from "zudoku";

const config: ZudokuConfig = {
  metadata: {
    title: "%s - kirim.dev",
    description: "Dokumentasi lengkap kirim.dev - Platform WhatsApp Business untuk mengirim pesan, mengelola kontak, dan integrasi API.",
  },
  site: {
    logo: {
      src: { light: "/logo-light.svg", dark: "/logo-dark.svg" },
      alt: "kirim.dev",
      width: "130px",
    },
  },
  navigation: [
    {
      type: "category",
      label: "Documentation",
      items: [
        // Introduction (homepage) - accessible at /
        {
          type: "doc",
          file: "index",
          path: "/",
          label: "Introduction",
          icon: "home",
        },
        // Getting Started
        {
          type: "category",
          label: "Getting Started",
          icon: "rocket",
          items: [
            "getting-started/quickstart",
          ],
        },
        // Overview
        {
          type: "category",
          label: "Overview",
          icon: "layout-dashboard",
          items: [
            "overview/dashboard",
            "overview/inbox",
            "overview/contacts",
          ],
        },
        // Campaigns
        {
          type: "category",
          label: "Campaigns",
          icon: "radio",
          items: [
            "campaigns/broadcast",
            "campaigns/templates",
            "campaigns/whatsapp-flows",
            "campaigns/quick-replies",
            "campaigns/ctwa-ads",
            "campaigns/automations",
          ],
        },
        // Developers
        {
          type: "category",
          label: "Developers",
          icon: "code",
          items: [
            "developers/index",
            "developers/api-keys",
            "developers/webhooks",
            "developers/logs",
            {
              type: "link",
              label: "API Reference",
              to: "/api",
              icon: "folder-cog",
            },
          ],
        },
        // Management
        {
          type: "category",
          label: "Management",
          icon: "settings",
          items: [
            "management/devices",
            "management/team-members",
            "management/ai-settings",
            "management/billing",
            "management/settings",
          ],
        },
      ],
    },
    {
      type: "link",
      to: "/api",
      label: "API Reference",
    },
  ],
  apis: [
    {
      type: "file",
      input: "./apis/openapi.yaml",
      path: "/api",
    },
  ],
};

export default config;
